import Config from '../config';
import { getApplication } from '../utils';
import {GetCall, ThirdPartyFormPostCall, PostCall} from './helper'

const URLS = {
  "FETCH_CITY": Config.BASE_API_URL + "/support/get_city_state",
  "FETCH_BRAND": Config.BASE_API_URL + "/shop/brand",
  "PRESIGNED_URL": Config.BASE_API_URL + "/v3/aws/get_presigned_post",
  "REFERRAL_URL": Config.BASE_API_URL + "/v3/referral/referral_url"
}

export const FetchCity = async(data:any) => {
  return await GetCall(URLS.FETCH_CITY, data, Config.DEFAULT_HEADER)
}

export const FetchBrand = async(data:any) => {
  return await GetCall(URLS.FETCH_BRAND, data, Config.DEFAULT_HEADER)
}

export const FetchPresignedurl = async(data:any) => {
  return await GetCall(URLS.PRESIGNED_URL, {application: getApplication(), ...data}, Config.DEFAULT_HEADER)
}

export const UploadToS3Bucket = async(url:any, data:any) => {
  return await ThirdPartyFormPostCall(url, data, {})
}

export const GetReferralUrl = async(data:any) => {
  return await PostCall(URLS.REFERRAL_URL, data, Config.DEFAULT_HEADER)
}

// V4 APPLICAITON BASE URLS
export const BASE_WEBSITE_V4_URL = Config.BASE_API_URL + '/v4/app:website'